import { useEffect, useState, type FC } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button, DialogActions, styled } from "@mui/material";
import { ModalWrapper } from "@/components/MediaSelector/MediaTypeTabPanel/ModalWrapper";
import { ApiRequest } from "@/declarations/ApiRequest";
import { useAuthError } from "@/AuthErrorContext";
import { StyledDialog } from "@/components/MediaSelector/FocalPointModal";
import Loader from "../Loader";

const ReStyledDialog = styled(StyledDialog)`
  .MuiDialog-paper {
    width: 100%;
    max-width: 600px;
    min-width: unset;
  }
`;
const StyledParagraph = styled("p")<{ loading: boolean }>`
  text-align: center;
  padding: 0 16px 48px;
  margin-top: 30px;
  margin-bottom: 0;

  ${({ loading }) => loading && ` padding-bottom: 0; `}
`;

export const AuthErrorModal: FC = () => {
  const { hasAuthError, setAuthError } = useAuthError();
  const history = useNavigate();

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    ApiRequest.onAuthError = () => setAuthError(true);
    return () => {
      ApiRequest.onAuthError = null;
    };
  }, [setAuthError]);

  const { t } = useTranslation("common");

  return (
    <ReStyledDialog maxWidth={"xs"} fullWidth open={hasAuthError} scroll={"paper"}>
      <ModalWrapper>
        <StyledParagraph loading={loading}>{t("authError.invalid_token")}</StyledParagraph>
        {loading && <Loader darkBackground={false} size={16} />}
      </ModalWrapper>
      <DialogActions>
        <Button
          type="button"
          color="primary"
          variant="contained"
          disabled={loading}
          onClick={() => {
            setLoading(true);
            history("/logout");
          }}
        >
          {t("authError.logout")}
        </Button>
        <Button
          type="button"
          color="primary"
          variant="contained"
          disabled={loading}
          onClick={() => {
            setLoading(true);
            window.location.reload();
          }}
        >
          {t("authError.reload")}
        </Button>
      </DialogActions>
    </ReStyledDialog>
  );
};
